<template>
	<div>
		<el-dialog
			title="查看附件"
			center
			:visible.sync="previewVisible"
			:top="fullHeight ? '0' : '10vh'"
			:width="fullHeight ? '100%' : '70%'"
			:custom-class="fullHeight ? 'preview-image-full-dialog' : ''"
			@closed="previewClose"
		>
			<div class="public-banner" :class="{ 'is-full': fullHeight }">
				<el-carousel :height="carouselHeight" :autoplay="autoplay" :arrow="previewSrcList.length > 1 ? 'always' : 'never'">
					<el-carousel-item v-for="(item, index) in previewSrcList" :key="index">
						<el-image
							v-if="isImage(item)"
							:src="item+'?timestamp='+Date.now()"
							:preview-src-list="previewSrcList"
							style="width: 100%; height: 100%;"
							fit="contain"
						/>
						<iframe v-else :src="item+'?timestamp='+Date.now()" frameborder="0" style="width: 100%; height: 100%;"></iframe>
						<!-- <div v-if="item && item.toLowerCase().indexOf('.pdf') > -1" style="text-align:center; margin-top:100px;">
						  <el-link :href="item" target="_blank" type="primary" style="font-size:20px;">该文件为pdf文件，请点击查看</el-link>
						</div> -->
					</el-carousel-item>
				</el-carousel>
			</div>
			<div style="text-align: right; margin-top: 30px;" v-if="fileInfo.linkNo">
				<el-button type="primary" size="small" @click="uploadSignInChange()" v-if="fileInfo.linkNo.startsWith('LINK') && fileInfo.linkNo.charAt(12) === '9' && fileInfo.linkNo.charAt(13) === '9'">上传签收单</el-button>
				<el-button type="primary" size="small" @click="updateReceiptStatus()" v-else>同步</el-button>
			</div>
		</el-dialog>

		<div>
			<el-dialog title="填写签收信息" center :visible.sync="isOneSignIn" class="public-dialog-upload" top="10vh" width="500px">
				<div class="public-form-main-wrap">
					<ul class="information-list column">
						<li v-if="signInOneParams.orderType == 1">
							<label class="upload-label" style="font-weight: bold">步骤1：</label>
							<div class="upload-content">
								<el-button type="text" size="small" @click="downOneSignInPdf()" v-loading="submitLoading">
									<span>点击下载签收单</span>
								</el-button>
							</div>
						</li>
						<li v-if="signInOneParams.orderType == 1">
							<label class="upload-label" style="font-weight: bold">步骤2：</label>
							<div class="upload-content">上传签字的签收单</div>
						</li>
						<li>
							<label></label>
							<div class="content-wrap double">
							<div class="files">
								<p v-for="(item, index) in 5" :key="index">
									<img :src="signInOneParams.imgs && signInOneParams.imgs[index] ? signInOneParams.imgs[index] : require('@/assets/request/signOneBg.png')" class="bg" />
									<img src="@/assets/request/close.png" class="close" @click.stop="closeSignIn(index)" />
									<img src="@/assets/request/signInText.png" class="text" />
									<input type="file" accept=".jpg,.png,.jpeg,.pdf" @change="uploadSignInFile" />
								</p>
							</div>
							</div>
						</li>
					</ul>
				</div>
				<div class="public-dialog-btns">
					<el-button type="primary" class="upload-btn" @click.stop="oneSignInPost()">上传</el-button>
					<el-button @click="isOneSignIn = false">取消</el-button>
				</div>
			</el-dialog>
		</div>
	</div>
</template>
<script>

export default {
props:{
	previewSrcList: {
		type: Array,
		required: true,
	},
	fileInfo: {
		type: Object,
		default: ()=>{
			return {}
		}
	},
	/** 是否自动轮播切换附件 */
	autoplay: {
		type: Boolean,
		default: false
	},
	/** 是否全屏高度展示（集采附件预览等场景） */
	fullHeight: {
		type: Boolean,
		default: false
	},
},
computed: {
	/**
	 * 轮播区域高度：全屏模式下占满可视区域，否则固定 500px。
	 */
	carouselHeight() {
		if (this.fullHeight) {
			return 'calc(100vh - 100px)';
		}
		return '500px';
	}
},
data() {
	return {
		previewVisible: false,
		// 上传签收单
		isOneSignIn: false,
		submitLoading: false,
		signInOneParams: {
			purchaseNo: "",
			orderType: 1,
			urls: [],
			imgs: [],
			deliverInfo: {
				deliveryNo: "",
				signType: "",
				signName: "",
				signRemark: "",
				signFormUrls: [],
			},
		},
	};
},
watch: {
	previewSrcList: {
		handler(newVal, oldVal) {
			this.previewOpen();
		},
		deep: true
	},
},
// mounted() {
// },
// filters: {
// 	formatDay(time) {
// 	  return time ? Moment(time).format("YYYY-MM-DD HH:mm:ss") : "";
// 	},
// 	formatSeconds(value) {
// 		if (!value) return '';

// 		let seconds = parseInt(value, 10);

// 		let minutes = Math.floor(seconds / 60);

// 		seconds = seconds % 60;

// 		minutes = minutes < 10 ? '0' + minutes : minutes;

// 		seconds = seconds < 10 ? '0' + seconds : seconds;
// 		if(minutes === '00'){
// 		  return seconds + '秒';
// 		}else {
// 		  return minutes + '分' + seconds + '秒';
// 		}
// 	},
// },
methods: {
	// 打开弹窗
	previewOpen(){
		if(this.previewSrcList && this.previewSrcList.length > 0){
			this.previewVisible = true;
		}
	},
	// 关闭弹窗
	previewClose(){
		// this.previewList = [];
	},
	// 判断是否为图片
	isImage(item) {
		return /\.(jpeg|jpg|gif|png)$/.test(item);
	},
	// 同步
	async updateReceiptStatus() {
		let res = await this.$http.post("/reqorder/updateReceiptStatus", [this.fileInfo.linkNo]);
		if(res.code == 200){
			this.$message.success("同步成功");
			this.$emit("operateResult", 'updateUrl');
		}
	},

	// 打开签收单
	async uploadSignInChange() {
		this.signInOneParams.purchaseNo = this.fileInfo.purchaseNo;
		if ( this.fileInfo.linkNo.startsWith("LINK") && !(this.fileInfo.linkNo.charAt(12) === "9" && this.fileInfo.linkNo.charAt(13) === "9") ) {
			this.signInOneParams.orderType = 0;
			this.signInOneParams.deliverInfo.signType = "客户已签收";
		} else {
			this.signInOneParams.orderType = 1;
		}
		this.isOneSignIn = true;
    },
	// 下载签收单
    async downOneSignInPdf() {
		this.submitLoading = true;

		let res = await this.$http.post("/reqorder/downOneSignInPdf", {
			purchaseNo: this.signInOneParams.purchaseNo,
		}).finally(() => {
			this.submitLoading = false;
		});
		if (res.code == 200) {
			window.open(res.result);
		}
    },
	// 选择文件
    async uploadSignInFile(e) {
		if (!e.target.files[0]) {
			return false;
		}

		const fd = new FormData();
		fd.append("file", e.target.files[0]);
		let res = await this.$http.post("/reqorder/upload", fd);
		if (res.code == 200) {
			this.$message({
				message: "成功",
				type: "success",
			});
			this.signInOneParams.urls.push(res.result.fileId);
			this.signInOneParams.imgs.push(res.result.url);
		}

		e.target.value = "";
    },
	// 上传
	async oneSignInPost() {
		if (this.signInOneParams.urls.length <= 0) {
			return this.$message({
				message: "请上传签收单",
				type: "warning",
			});
		}

		let loading = this.$loading({
			lock: true,
			text: "AI识别中，请稍等",
			spinner: "el-icon-loading",
			background: "rgba(0, 0, 0, 0.7)",
		});

      	let res = await this.$http.post("/reqorder/receipt/upload", this.signInOneParams);
      	loading.close();
		if (res.code == 200) {
			this.$message({
				message: "上传成功",
				type: "success",
			});
			this.isOneSignIn = false;
			this.signInOneParams = {
				purchaseNo: "",
				orderType: 1,
				urls: [],
				imgs: [],
				deliverInfo: {
					deliveryNo: "",
					signType: "",
					signName: "",
					signRemark: "",
					signFormUrls: [],
				},
			};
			this.$emit("operateResult", 'updateUrl');
		}
    },
},
};
</script>
<style lang="less">
.preview-image-full-dialog {
	margin: 0 !important;
	height: 100vh;
	max-height: 100vh;
	display: flex;
	flex-direction: column;
	.el-dialog__header {
		flex-shrink: 0;
	}
	.el-dialog__body {
		flex: 1;
		overflow: hidden;
		display: flex;
		flex-direction: column;
		min-height: 0;
		padding-bottom: 16px;
	}
}
</style>
<style lang="less" scoped>
.public-banner {
	&.is-full {
		flex: 1;
		min-height: 0;
	}
	/deep/.el-carousel__indicators {
		padding: 0 20px;
		border-radius: 50px;
		background-color: rgba(96, 98, 102, .5);
		.el-carousel__indicator {
			vertical-align: top;
		}
	}
}
</style>
